import { render, staticRenderFns } from "./PageNavigationList.vue?vue&type=template&id=6463eac0&scoped=true&"
import script from "./PageNavigationList.vue?vue&type=script&lang=js&"
export * from "./PageNavigationList.vue?vue&type=script&lang=js&"
import style0 from "./PageNavigationList.vue?vue&type=style&index=0&id=6463eac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6463eac0",
  null
  
)

export default component.exports